import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('metal_detection')
export class MetalDetectionEntity {
    @PrimaryGeneratedColumn("increment", { name: 'm_detection_id' })
    metalDetectionId: number;

    @Column({
        nullable: true,
        name: 'date',
    })
    date: Date;

    @Column({
        type: 'int',
        nullable: false,
        name: 'min_grade'
    })
    minGrade: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'max_grade'
    })
    maxGrade: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'variety'
    })
    variety: number;

    @Column({
        type: 'int',
        nullable: true,
        name: 'brand'
    })
    brand: number;

    @Column("varchar", {
        nullable: true,
        length: 50,
        name: "s_code"
    })
    sCode: string;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "operation"
    })
    operation: string;


    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'mm_fe'
    })
    mmFe: boolean;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'mm_non_fe'
    })
    mmNonFe: boolean;


    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'mm_ss'
    })
    mmSS: boolean;

    @Column({
        type: 'int',
        nullable: false,
        name: 'min_pouches'
    })
    minPouches: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'max_pouches'
    })
    maxPouches: number;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'metal_detected'
    })
    metalDetected: boolean;

    @Column("varchar", {
        nullable: true,
        length: 30,
        name: "corrective_action"
    })
    correctiveAction: string;

    @Column({
        type: 'int',
        nullable: false,
        name: 'plant'
    })
    plant: number;

    @Column('boolean', {
        nullable: false,
        default: true,
        name: 'is_active'
    })
    isActive: boolean;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;
}